module.exports = __webpack_public_path__ + "static/img/Ewm.de30bc3e.jpg";